<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <label>开始日期</label>
            <DatePicker
                v-model="startDate"
                transfer
                :class="preCls + 'select-public-style'"
                type="date"
                @on-change="clearFast"
            ></DatePicker>
            <label>结束日期</label>
            <DatePicker
                v-model="endDate"
                transfer
                :class="preCls + 'select-public-style'"
                type="date"
                @on-change="clearFast"
            ></DatePicker>
            <check-tag-group
                style="display: inline-block"
                v-model="fastDate"
                color="primary"
                @on-change="getEndStart"
            >
                <check-tag v-for="item in fastDateList" :name="item.id" :key="item.id">{{item.text}}</check-tag>
            </check-tag-group>
            <Tabs class="router-view" :animated="false" v-model="active">
                <TabPane label="工单回收" :index="1" name="recycleOrder">
                    <Access name="recycleOrder">
                        <router-view
                            :date="filter"
                            orderDataSource="G"
                            v-if="active == 'recycleOrder'"
                            :name="$access.aliasToUri('recycleOrder')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="任务回收" :index="2" name="recycleTask">
                    <Access name="recycleTask">
                        <router-view
                            :date="filter"
                            orderDataSource="R"
                            v-if="active == 'recycleTask'"
                            :name="$access.aliasToUri('recycleTask')"
                        ></router-view>
                    </Access>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'ivux'
import dayjs from 'dayjs'
export default {
    components: {
        Tabs,
        TabPane
    },
    data() {
        return {
            active: 'recycleOrder',
            fastDateList: [
                { id: 7, text: '近7天' },
                { id: 30, text: '近30天' },
                { id: 90, text: '近90天' }
            ],
            filter: {
                startDate: this.$cache.startDate,
                endDate: this.$cache.endDate
            },
            fastDate: []
        }
    },
    computed: {
        startDate: {
            get() {
                return this.filter.startDate
                    ? new Date(this.filter.startDate)
                    : ''
            },
            set(el) {
                this.filter.startDate = el ? dayjs(el).format('YYYY-MM-DD') : ''
                this.$cache.startDate = this.filter.startDate
            }
        },
        endDate: {
            get() {
                return this.filter.endDate ? new Date(this.filter.endDate) : ''
            },
            set(el) {
                this.filter.endDate = el ? dayjs(el).format('YYYY-MM-DD') : ''
                this.$cache.endDate = this.filter.endDate
            }
        }
    },
    methods: {
        getEndStart(el) {
            if (el && el.length) {
                let body = {
                    startDate: dayjs()
                        .subtract(el[0], 'day')
                        .format('YYYY-MM-DD'),
                    endDate: dayjs().format('YYYY-MM-DD')
                }
                this.filter = body
            }
        },
        clearFast() {
            this.fastDate = []
        }
    }
}
</script>